document.addEventListener("cart:updating", () => setCheckoutDisabled(true));

document.addEventListener("cart:updated", async (evt) => {
  setCheckoutDisabled(true);

  try {
    const { items, original_total_price } = evt.detail.cart;
    await handleAutomaticProductByPrice(items, original_total_price);
    await handleAutomaticProductByCollection(items);
  } finally {
    setCheckoutDisabled(false);
  }
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeAutomaticProducts);
} else {
  initializeAutomaticProducts();
}

async function initializeAutomaticProducts() {
  try {
    const cart = await window.getCart();
    if (!cart?.items) return;

    await handleAutomaticProductByPrice(cart.items, cart.original_total_price);
    await handleAutomaticProductByCollection(cart.items);
  } catch (error) {
    console.error("Error initializing automatic products:", error);
  }
}

function setCheckoutDisabled(disabled) {
  document
    .querySelectorAll(".quick-cart__submit, .cart__submit")
    .forEach((button) => {
      button.disabled = disabled;
    });
}

function isAutomaticGiftLine(cartItem) {
  const properties = cartItem.properties || {};

  return (
    properties._automatic_products_by_price !== undefined ||
    properties._automatic_products_by_collection !== undefined
  );
}

function checkIfAutomaticProductsExist(cartItems, type) {
  return cartItems.filter((item) => item.properties?.[type] !== undefined);
}

async function removeAutomaticProducts(products) {
  for (const product of products) {
    await window.updateItem(product.key, 0);
  }
}

async function addAutomaticProduct(variantData) {
  await window.addtems(variantData);
}

async function handleAutomaticProductByPrice(cartItems, totalPrice) {
  const automaticProductElement = document.getElementById("automatic-product");
  if (!automaticProductElement) return;

  const { minPriceThreshold, autoProductVariantId, autoProductVariantIds } =
    automaticProductElement.dataset;
  if (!minPriceThreshold) return;

  const productVariantIds = autoProductVariantIds
    ? autoProductVariantIds.split(",")
    : autoProductVariantId
      ? [autoProductVariantId]
      : [];
  if (!productVariantIds.length) return;

  const automaticProductsByPrice = checkIfAutomaticProductsExist(
    cartItems,
    "_automatic_products_by_price",
  );
  const productsInCart = automaticProductsByPrice.map((item) =>
    item.variant_id.toString(),
  );
  const productsToAdd = productVariantIds.filter(
    (variantId) => !productsInCart.includes(variantId),
  );
  const productsToRemove = automaticProductsByPrice.filter(
    (item) => !productVariantIds.includes(item.variant_id.toString()),
  );

  if (totalPrice / 100 >= Number(minPriceThreshold)) {
    if (productsToRemove.length) await removeAutomaticProducts(productsToRemove);
    if (productsToAdd.length) {
      return addAutomaticProduct({
        items: productsToAdd.map((variantId) => ({
          id: variantId,
          quantity: 1,
          properties: { _automatic_products_by_price: true },
        })),
      });
    }
  } else if (automaticProductsByPrice.length) {
    await removeAutomaticProducts(automaticProductsByPrice);
  }
}

async function handleAutomaticProductByCollection(cartItems) {
  const automaticProductByCollectionElement = document.getElementById(
    "automatic-product-by-collection",
  );
  if (!automaticProductByCollectionElement) return;

  const { collectionQuantity, collectionIds, autoProductVariantIds } =
    automaticProductByCollectionElement.dataset;
  if (!(collectionQuantity && collectionIds && autoProductVariantIds)) return;

  const targetCollectionIds = collectionIds.split(",").map((id) => id.trim());
  const productVariantIds = autoProductVariantIds
    .split(",")
    .map((id) => id.trim());
  if (!targetCollectionIds.length || !productVariantIds.length) return;

  const automaticProductsByCollection = checkIfAutomaticProductsExist(
    cartItems,
    "_automatic_products_by_collection",
  );
  const productsInCart = automaticProductsByCollection.map((item) =>
    item.variant_id.toString(),
  );
  const productsToAdd = productVariantIds.filter(
    (variantId) => !productsInCart.includes(variantId),
  );
  const productsToRemove = automaticProductsByCollection.filter(
    (item) => !productVariantIds.includes(item.variant_id.toString()),
  );

  let quantityByCollectionInCart = 0;
  for (const cartElement of cartItems) {
    if (isAutomaticGiftLine(cartElement)) continue;

    const itemCollectionIds = cartElement.properties?._collection_ids;
    if (!itemCollectionIds) continue;

    const itemCollections = itemCollectionIds.split(",").map((id) => id.trim());
    if (itemCollections.some((id) => targetCollectionIds.includes(id))) {
      quantityByCollectionInCart += cartElement.quantity;
    }
  }

  if (quantityByCollectionInCart >= Number(collectionQuantity)) {
    if (productsToRemove.length) await removeAutomaticProducts(productsToRemove);
    if (productsToAdd.length) {
      return addAutomaticProduct({
        items: productsToAdd.map((variantId) => ({
          id: variantId,
          quantity: 1,
          properties: { _automatic_products_by_collection: true },
        })),
      });
    }
  } else if (automaticProductsByCollection.length) {
    await removeAutomaticProducts(automaticProductsByCollection);
  }
}
